import { Component } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CadastroDocumentoTipo, FileDto } from '@usucampeao/lib-reurb-simplificado';
import { ArquivosEnviadosRemovidos, BaseComponent, LoadingService, ToastService } from '@usucampeao/ui-mobile';
import { Observable } from 'rxjs';
import { catchError, finalize, switchMap, takeUntil, tap } from 'rxjs/operators';
import { CadastroService } from '../../../pages/cadastros/state/cadastros.service';

@Component({
  template: ''
})
export abstract class CadastroDocumentosUpload extends BaseComponent {
  protected cadastroId: string;
  public tipo: CadastroDocumentoTipo;
  public documentoId: string;
  public arquivos: FileDto[] = [];

  constructor(
    protected readonly cadastroService: CadastroService,
    protected readonly loadingService: LoadingService,
    protected readonly route: ActivatedRoute,
    protected readonly router: Router,
    protected readonly toastService: ToastService,
  ) {
    super();
  }

  protected carregarDadosDaRota(): Observable<Params> {
    return this.route.queryParams
      .pipe(
        tap(params => {
          this.tipo = params.tipo;

          if (!this.tipo) {
            this.router.navigate(['..'], { relativeTo: this.route });
          }
        }),
        tap(params => this.documentoId = params.documentoId),
        tap(() => this.carregarDocumento()),
        switchMap(() => this.route.params),
        tap(params => this.cadastroId = params.cadastroId),
        takeUntil(this.ngUnsubscribe$),
      );
  }

  private async carregarDocumento(): Promise<void> {
    if (!this.documentoId) {
      return;
    }

    await this.loadingService.createLoader();
    this.cadastroService.buscarArquivosDocumento(this.documentoId)
      .pipe(
        tap(arquivos => this.arquivos = arquivos),
        catchError(() => this.toastService.error('Erro ao carregar documento. Por favor tente novamente')),
        finalize(() => this.loadingService.dismiss()),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe();
  }

  public adicionarOuAtualizarDocumento(arquivos: ArquivosEnviadosRemovidos): void {
    if (this.documentoId) {
      this.atualizarDocumento(arquivos);
    } else {
      this.adicionarDocumento(arquivos.arquivosEnviados);
    }
  }

  private async adicionarDocumento(arquivos: File[]): Promise<void> {
    await this.loadingService.createLoader();

    this.cadastroService.uploadDocumentosDoCadastro(this.cadastroId, arquivos, this.tipo)
      .pipe(
        switchMap(() => this.toastService.success('Documento adicionado com sucesso')),
        tap(() => this.navegarParaProxima()),
        catchError(async error => {
          await this.toastService.error('Erro ao salvar documento. Por favor tente novamente').toPromise();
          throw error;
        }),
        finalize(async () => this.loadingService.dismiss()),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe();
  }

  private async atualizarDocumento(arquivos: ArquivosEnviadosRemovidos): Promise<void> {
    await this.loadingService.createLoader();

    this.cadastroService.atualizarDocumento(this.cadastroId, this.documentoId, arquivos.arquivosEnviados, arquivos.idsArquivosRemovidos)
      .pipe(
        switchMap(() => this.toastService.success('Documento atualizado com sucesso')),
        tap(() => this.navegarParaProxima()),
        catchError(async error => {
          await this.toastService.error('Erro ao atualizar documento. Por favor tente novamente').toPromise();
          throw error;
        }),
        finalize(async () => this.loadingService.dismiss()),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe();
  }

  protected abstract navegarParaProxima(): void;
}